

<div class="search">
    <button class="btn btn-info btn-purchasenewpack" (click)="createNew()">Register New Vendor</button>
    <button class="btn btn-info btn-purchasenewpack" (click)="createNewUser()">New Vendor User</button>
    <div class="search-input-icon">
        <div class="search-input"><i class="flaticon-search"></i></div>
        <input type='text' [placeholder]='"Search Merchants.."' (keyup)='search()' [(ngModel)]="searchText" class="searchtext"/>
    </div>
</div>
<br>

<ngx-spinner
    bdColor="rgba(75, 55, 100, 0.5)"
    size="large"
    color="#fff"
    type="line-scale-pulse-out">
        <span class="chevron left"></span>
        <span class="chevron right"></span>
</ngx-spinner>

<ngx-datatable #packageTable
               class='material striped datatable'
               [rows]='displayItems'
               [columnMode]='"force"'               
               [headerHeight]='40'
               [footerHeight]='20'
               [scrollbarH]="true"
               [scrollbarV]="true"
               [rowHeight]="40"
               [messages]='{emptyMessage:"No vendors to display here!"}'
               [reorderable]="true">

    <ngx-datatable-column prop="status" [sortable]="true" [width]="60" [minWidth]="60" [maxWidth]="60">
        <ng-template let-column="column"  ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">Status</span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            <div class="center">
                <div placement="right" container="body" tooltip="Vendor hasn't accepted the portal invite" *ngIf="!row.vendor.active && !row.vendor.verified" style="background-color:orangered;" class="circle"></div>
                <div placement="right" container="body" tooltip="Vendor has created their portal login, but hasn't registered with Stripe" *ngIf="!row.vendor.active && row.vendor.verified" style="background-color:yellow;" class="circle"></div>
                <div placement="right" container="body" tooltip="Vendor onboarding is complete" *ngIf="row.vendor.active && row.vendor.verified" style="background-color:green;" class="circle"></div>
            </div>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="name" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Vendor Name
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.vendor.name}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="name" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Email
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.user.email}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="name" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                User's Name
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.user.firstName}} {{row.user.lastName}} 
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="name" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Primary Contact
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{ row.primaryContact ? 'Yes' : 'No' }}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="createdBy" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Created By
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.vendor.createdBy}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="modifiedBy" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Modified By / Date
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.vendor.modifiedBy ? row.vendor.modifiedBy : 'empty'}} / {{row.vendor.dateModified | date:'MM-d-y'}}
        </ng-template>
    </ngx-datatable-column> 

    <ngx-datatable-column prop="dateCreated" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Date Created (UTC)
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.vendor.dateCreated | date:'EEEE, MMMM d, y'}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="dateCreated" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Last Active (UTC)
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.user.lastActive | date:'EEEE, MMMM d, y'}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="pledgePerWinAdminPercent" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                PPW Admin Fee %
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{ row.vendor.pledgePerWinAdminPercent }}%
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column  [sortable]="false" [minWidth]="200" [maxWidth]="200">
        <ng-template let-column="column" ngx-datatable-header-template class="actions-row">
            <span></span>
        </ng-template>
        <ng-template prop="actions" let-row="row" ngx-datatable-cell-template >
            <!--<button style="float: right;" class="btn btn-danger btn-icon" (click)="delete(row)"><i class="flaticon-cancel"></i></button>-->
            <button style="float: right;" *ngIf="row.primaryContact" class="btn btn-success btn-icon" (click)="edit(row)"><i class="flaticon-edit-1"></i></button>
            <button style="float: right;" [debounceClick] *ngIf="row.primaryContact && !row.vendor.active && !row.vendor.verified" class="btn btn-info btn-icon" (click)="resendPortalOnboardingUrl(row.vendor)"><i class="flaticon-paper-plane"></i></button>
            <button style="float: right;" *ngIf="row.primaryContact && row.vendor.active && row.vendor.verified" class="btn btn-info btn-icon" (click)="openAccountLinkModal(row.vendor.vendorId)"><i class="flaticon-map"></i></button>
            <button style="float: right;" *ngIf="!row.primaryContact" class="btn btn-danger btn-icon" (click)="deleteVendorUser(row.fundraisingVendorUserId)"><i class="flaticon-cancel"></i></button>
        </ng-template>
    </ngx-datatable-column>
</ngx-datatable>





